// /wechat-pay/recharge/packages
import request from '@/utils/request';
import { CreateRechargeOrder, RechargeOrder, RechargePackage, ResponseDTO } from '@/types';

export function getRechargePackages(): Promise<RechargePackage[]> {
  return request
    .get<RechargePackage[], ResponseDTO<RechargePackage[]>>('/wechat-pay/recharge/packages')
    .then((res) => res.data);
}

// 创建微信支付订单，获取支付二维码
export function createRechargeOrder(packageId: string): Promise<CreateRechargeOrder> {
  return request
    .post<CreateRechargeOrder, ResponseDTO<CreateRechargeOrder>>(
      '/wechat-pay/recharge/create-order',
      { packageId },
    )
    .then((res) => res.data);
}

// 根据订单号查询订单状态
export function getRechargeOrder(orderNo: string): Promise<RechargeOrder> {
  return request
    .get<RechargeOrder, ResponseDTO<RechargeOrder>>(`/wechat-pay/recharge/order/${orderNo}`)
    .then((res) => res.data);
}
